declare namespace $ {

	export class $mol_icon_screw_lag extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=lag.view.tree.d.ts.map